// extracted by mini-css-extract-plugin
module.exports = {"root":"profileAvatar_root__8VWPI","hiddenFileInput":"profileAvatar_hiddenFileInput__XHuXs","actions":"profileAvatar_actions__13BX_"};